import Logo from '../logos/etsim';

export default Logo;
